// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const CNT_CMB_ST = {
  EmDigitacao: 'CNT_CMB_ST1',
  Contratado: 'CNT_CMB_ST2',
  LiquidadoParcialmente: 'CNT_CMB_ST3',
  LiquidadoTotal: 'CNT_CMB_ST4',
  Expirado: 'CNT_CMB_ST5',
  Baixado: 'CNT_CMB_ST6',
  Cancelado: 'CNT_CMB_ST7',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    CNT_CMB_ST1: 1,
    CNT_CMB_ST2: 2,
    CNT_CMB_ST3: 3,
    CNT_CMB_ST4: 4,
    CNT_CMB_ST5: 5,
    CNT_CMB_ST6: 6,
    CNT_CMB_ST7: 7
  }
}
